<template>
  <div>
    <p style="text-align: center">
      <!--      <span class="systemFont0">{{ $t("newYouHuiMa.createCouponCode") }}</span>-->
      <span class="systemFont0">{{ $t("emailGroup.createEmailGroup") }}</span>
    </p>
    <div class="main">
      <el-form
        class="systemFont1"
        :model="emailGroup"
        label-width="150px"
        style="width:90%;"
        ref="searchForm"
        :rules="searchRules"
      >
        <!--  新增Email群名称-->
        <el-row>
          <el-col :span="22" :offset="2">
            <el-form-item
              :label="$t('emailGroup.newEmailGroupName')"
              prop="groupName"
            >
              <el-input
                type="text"
                v-model="emailGroup.groupName"
                maxlength="255"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--  Email群摘要/描述  -->
        <el-row>
          <el-col :span="22" :offset="2">
            <el-form-item
              :label="$t('emailGroup.newEmailGroupDesc')"
              prop="groupDesc"
            >
              <el-input
                resize="none"
                :rows="3"
                type="textarea"
                v-model="emailGroup.groupDesc"
                maxlength="500"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" :offset="2">
            <!-- 现任职公司 -->
            <el-form-item :label="$t('emailGroup.curCompany')">
              <el-input
                v-model="emailGroup.curCompany"
                :placeholder="$t('emailGroup.fuzzySearch')"
                size="small"
              ></el-input>
            </el-form-item>
            <!-- 学历 -->
            <el-form-item :label="$t('emailGroup.education')">
              <el-select
                v-model="emailGroup.education"
                size="small"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
                clearable
              >
                <el-option
                  v-for="item in educationList"
                  :key="Number(item.educationKey)"
                  :label="item.educationName"
                  :value="item.educationKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 证书 -->
            <el-form-item
              :label="$t('newYouHuiMa.certificate')"
              prop="certificate"
            >
              <el-select
                multiple
                v-model="emailGroup.certificate"
                size="small"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
                clearable
              >
                <el-option
                  v-for="item in certificateList"
                  :key="item.certificateName"
                  :label="item.certificateName"
                  :value="item.certificateName"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <!-- 曾任职公司 -->
            <el-form-item
              :label="$t('emailGroup.beforeCompany')"
              prop="beforeCompany"
            >
              <el-input
                v-model="emailGroup.beforeCompany"
                :placeholder="$t('emailGroup.fuzzySearch')"
                size="small"
              ></el-input>
            </el-form-item>
            <!-- 毕业年份 -->
            <el-form-item
              :label="$t('emailGroup.graduateYear')"
              prop="graduate"
            >
              <el-date-picker
                v-model="emailGroup.graduateLeft"
                type="year"
                size="small"
                style="width: calc(50% - 1.1rem)"
                @change="graduateChange"
                value-format="yyyy"
                :placeholder="$t('common.pleaseSelect')"
              >
              </el-date-picker>
              <span style="width: 24px;display: inline-block;"
                >&nbsp;{{ $t("emailGroup.to") }}&nbsp;</span
              >
              <el-date-picker
                v-model="emailGroup.graduateRight"
                type="year"
                size="small"
                style="width: calc(50% - 1.1rem)"
                @change="graduateChange"
                value-format="yyyy"
                :placeholder="$t('common.pleaseSelect')"
              >
              </el-date-picker>
            </el-form-item>
            <!-- TQS模块使用 -->
            <el-form-item :label="$t('newYouHuiMa.TQSTemplateUsage')">
              <el-select
                v-model="emailGroup.useTQS"
                size="small"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
                clearable
              >
                <el-option
                  v-for="item in tqsModuleList"
                  :key="item.tqsModuleKey"
                  :label="item.tqsModuleName"
                  :value="item.tqsModuleKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" :offset="2">
            <!-- 绿夹克上课名称 -->
            <el-form-item
              :label="$t('newYouHuiMa.greenJacketClassName')"
              prop="className"
            >
              <el-select
                multiple
                v-model="emailGroup.className"
                size="small"
                style="width: 100%"
                @change="getScheduleByCourse(emailGroup.className)"
                :placeholder="$t('common.pleaseSelect')"
                clearable
              >
                <el-option
                  v-for="item in courseNameList"
                  :key="item.courseNumber"
                  :label="item.courseName"
                  :value="item.courseNumber"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <!-- 绿夹克上课日期 -->
            <el-form-item :label="$t('newYouHuiMa.greenJacketClassDate')">
              <el-select
                v-model="emailGroup.classDate"
                size="small"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
                clearable
              >
                <el-option
                  v-for="item in classDateList"
                  :key="item.courseDate"
                  :label="item.courseDate"
                  :value="item.courseDate"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" :offset="2">
            <!-- 优惠码级别 -->
            <el-form-item :label="$t('emailGroup.couponCodeLevel')">
              <el-select
                v-model="emailGroup.couponCodeLevel"
                size="small"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
                clearable
              >
                <el-option
                  v-for="item in promoCodeLevelOption"
                  :key="item.levelKey"
                  :label="item.levelValue"
                  :value="item.levelKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <!-- 关键字 -->
            <el-form-item :label="$t('emailGroup.userSearchValue')">
              <el-input
                :placeholder="$t('emailGroup.qtr')"
                v-model="emailGroup.userSearchValue"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" :offset="2">
            <!-- 标签 -->
            <el-form-item :label="$t('p0213.tag')">
              <el-select
                v-model="emailGroup.tagList"
                size="small"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
                multiple
                clearable
              >
                <el-option
                  v-for="item in tagOpList"
                  :key="item.codeKey"
                  :label="item.codeValue"
                  :value="item.codeKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <!-- 分区 -->
            <el-form-item :label="$t('p0213.subarea')">
              <el-input
                v-model="emailGroup.subarea"
                :placeholder="$t('emailGroup.fuzzySearch')"
                maxlength="64"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22" :offset="2">
            <!-- 所属机构 -->
            <el-form-item :label="$t('p0213.affiliation')">
              <el-select
                v-model="emailGroup.institution"
                size="small"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
                multiple
                clearable
              >
                <el-option
                  v-for="item in institutionOptList"
                  :key="item.codeKey"
                  :label="item.codeValue"
                  :value="item.codeKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22" :offset="2">
            <!-- 区域 -->
            <el-form-item :label="$t('p0213.region')">
              <div v-for="(userLocation, userLocationIndex) in emailGroup.userLocationList" :key="'regionuserLocation'+userLocationIndex">
                <el-col :span="21">
                  <RegionSelection
                    :ref="'RegionSelectionRef'+userLocationIndex"
                    :disabled="false"
                    :formData="userLocation"
                    :required="false"
                    class="baseTab-inputWidth"
                    size="small"
                  />
                </el-col>
                <el-col :span="3" style="padding-left: 6px;">
                  <el-form-item class="plusAndMinus">
                    <img
                      v-if="userLocationIndex == 0"
                      class="add-icon"
                      src="@/assets/add.svg"
                      @click="addLocation()"
                    />
                    <img
                      v-if="userLocationIndex != 0"
                      class="subtract-icon"
                      src="@/assets/subtract.svg"
                      @click="deleteLocation(userLocation)"
                    />
                  </el-form-item>
                </el-col>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: center">
      <el-button type="submit" @click="query()"
        >{{ $t("common.query") }}
      </el-button>
      <el-button type="submit" class="buttonWidth" @click="reset()"
        >{{ $t("common.reset") }}
      </el-button>
    </div>
    <!-- 用户列表 -->
    <div v-if="showFlag" style="margin-top: 50px;overflow: auto;">
      <el-table
        ref="userList"
        :data="userList"
        tooltip-effect="dark"
        style="width:90%;margin:auto"
        :row-key="getRowKey"
        @select-all="handleAllSelChange"
        @select="handleRowSelChange"
      >
        <el-table-column
          fixed="left"
          type="selection"
          align="center"
          width="55"
          :reserve-selection="true"
        ></el-table-column>
        <!-- 头像 -->
        <el-table-column
          min-width="60"
          :label="$t('newYouHuiMa.avatar')"
          align="center"
        >
          <template slot-scope="scope">
            <el-avatar
              :src="viewHeadPortrait(scope.row.headPortrait)"
              :key="scope.row.headPortrait"
              :size="30"
            ></el-avatar>
          </template>
        </el-table-column>
        <!-- 姓名-->
        <el-table-column
          min-width="80"
          :label="$t('newYouHuiMa.name')"
          align="center"
        >
          <!-- 姓名 -->
          <template slot-scope="scope">
            {{ scope.row.lastName + " " + scope.row.firstName }}
          </template>
        </el-table-column>
        <!-- 英文姓名 -->
        <el-table-column
          :label="$t('newYouHuiMa.englishName')"
          min-width="120"
          align="center"
        >
          <!-- 英文姓名 -->
          <template slot-scope="scope">
            {{
              scope.row.lastNameEn === null
                ? ""
                : scope.row.lastNameEn + " " + scope.row.firstNameEn
            }}
          </template>
        </el-table-column>
        <!--昵称-->
        <el-table-column
          :label="$t('emailGroup.nickName')"
          min-width="75"
          align="center"
        >
          <!-- 昵称 -->
          <template slot-scope="scope">
            {{ scope.row.nickname }}
          </template>
        </el-table-column>
        <!-- 优惠码 -->
        <el-table-column
          prop="couponCode"
          :label="$t('p0401.promoCode')"
          min-width="100"
          align="left"
        ></el-table-column>
        <!-- 优惠码级别 -->
        <el-table-column
          prop="couponCodeLevel"
          :label="$t('p0401.promoCodeLevel')"
          min-width="100"
          align="left"
        ></el-table-column>
        <!-- 关联公司 -->
        <el-table-column
          prop="affiliation"
          :label="$t('newYouHuiMa.affiliation')"
          align="left"
          min-width="250"
        ></el-table-column>
        <!-- 职位 -->
        <el-table-column
          prop="position"
          :label="$t('p0401.position')"
          align="left"
        ></el-table-column>
        <!-- 手机号码 -->
        <el-table-column
          :label="$t('newYouHuiMa.phoneNumber')"
          min-width="150"
          align="center"
        >
          <!-- 手机号码 -->
          <template slot-scope="scope">
            {{
              scope.row.phoneNo === null
                ? scope.row.supplyPhoneNumber
                : scope.row.phoneArea + " " + scope.row.phoneNo
            }}
          </template>
        </el-table-column>
        <!-- 邮箱 -->
        <el-table-column
          :label="$t('emailGroup.email')"
          min-width="250"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.email || scope.row.supplyEmail }}
          </template>
        </el-table-column>
        <!-- 注册日期 -->
        <el-table-column
          prop="createTime"
          min-width="100"
          :label="$t('newYouHuiMa.registerDate')"
          align="center"
        ></el-table-column>
        <!-- 标签 -->
        <el-table-column
          prop="tagList"
          min-width="250"
          :label="$t('p0213.tag')"
          align="left"
          show-overflow-tooltip
        ></el-table-column>
        <!-- 所属机构 -->
        <el-table-column
          prop="institution"
          min-width="250"
          :label="$t('p0213.affiliation')"
          align="left"
          show-overflow-tooltip
        ></el-table-column>
        <!-- 区域 -->
        <el-table-column
          prop="regionList"
          min-width="250"
          :label="$t('p0213.region')"
          align="left"
        >
          <template slot-scope="scope">
            <div class="region-cell">
              <div v-for="(region, index) in (scope.row.regionList ? scope.row.regionList.split('; ') : [])" :key="index" class="region-item">
                {{ region }}
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 分区 -->
        <el-table-column
          prop="subarea"
          min-width="120"
          :label="$t('p0213.subarea')"
          align="left"
          show-overflow-tooltip
        ></el-table-column>
        <!-- 介绍人 -->
        <el-table-column
          prop="introducer"
          :label="$t('p0401.intro')"
          align="left"
        ></el-table-column>
        <!-- 销售人员 -->
        <el-table-column
          prop="salesperson"
          :label="$t('p0401.sales')"
          align="left"
        ></el-table-column>
        <!-- TQS操作 -->
        <el-table-column
          prop="operationDetailZh"
          :label="$t('p0401.tqsOperation')"
          align="left"
          min-width="200"
        ></el-table-column>
        <!-- TQS积分 -->
        <el-table-column
          prop="sumPoints"
          :label="$t('p0401.tqsPoints')"
          align="left"
        ></el-table-column>
        <!-- 上次更新 -->
        <el-table-column
          prop="updateTime"
          :label="$t('p0401.lastUpdated')"
          align="left"
          min-width="100"
        ></el-table-column>
        <!-- 上次登录 -->
        <el-table-column
          prop="loginTime"
          min-width="100"
          :label="$t('newYouHuiMa.lastLogin')"
          align="center"
        ></el-table-column>
        <!-- 操作 -->
        <el-table-column
          fixed="right"
          :label="$t('common.operation')"
          min-width="70"
          align="center"
        >
          <template slot-scope="scope">
            <el-button size="text" @click="detail(scope.row)"
              >{{ $t("common.details") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div v-if="showFlag && total > 0" class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
      <el-row
        class="foot-container"
        style="margin-bottom: 50px;text-align:center"
      >
        <el-col :span="8">
          <!--创建并通知  -->
          <el-button type="p0332Button" @click="handleSubmit()"
            >{{ $t("common.submit") }}
          </el-button>
        </el-col>
        <el-col :span="8">
          <!--导出  -->
          <el-button type="p0332Button" @click="exportExcel()"
            >{{ $t("p0416.export") }}
          </el-button>
        </el-col>
        <el-col :span="8">
          <!-- 返回 -->
          <el-button
            type="return"
            @click="
              () => {
                this.$router.go(-1);
              }
            "
            >{{ $t("common.back") }}
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import moment, { now } from "moment";
import RegionSelection from "./RegionSelection.vue";

export default {
  components: {
    RegionSelection
  },
  data() {
    const validatorGraduate = (rule, value, callback) => {
      if (
        this.emailGroup.graduateLeft !== "" &&
        this.emailGroup.graduateRight !== ""
      ) {
        if (this.emailGroup.graduateLeft > this.emailGroup.graduateRight) {
          callback(new Error(this.$t("emailGroup.graduate")));
        }
      }
      callback();
    };
    const validatorGroupName = (rule, value, callback) => {
      // console.log(value);
      if (!this.emailGroup.groupName) {
        callback(new Error(this.$t("emailGroup.inputGroupName")));
      }
      callback();
    };
    const validatorGroupNameLength = (rule, value, callback) => {
      if (value && value.length > 255) {
        callback(new Error(this.$t("emailGroup.maxLength255")));
      }
      callback();
    };
    const validatorGroupDesc = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("emailGroup.inputGroupDesc")));
      }
      callback();
    };
    const validatorGroupDescLength = (rule, value, callback) => {
      if (value && value.length > 500) {
        callback(new Error(this.$t("emailGroup.maxLength500")));
      }
      callback();
    };
    return {
      /** 默认头像 */
      defaultImg: require("../../../assets/headPortrait.png"),
      levelValue: 0,
      /**  学历 */
      educationList: [],
      /**  表格显示状态 */
      showFlag: false,
      userList: [],
      allUserIds: [],
      allSelFlg: true,
      /** 当前页 */
      currentPage: 1,
      /** 每页件数 */
      pageSize: 30,
      /** 总条数 */
      total: 0,
      /**  Email群 table */
      emailGroup: {
        /** 群名称 */
        groupName: "",
        /**  群描述 */
        groupDesc: "",
        /**  现任职公司 */
        curCompany: "",
        /** 学历 */
        education: "",
        /**  证书 */
        certificate: [],
        /**  绿夹克课程名称 */
        className: [],
        /**  优惠码级别 */
        couponCodeLevel: "",
        /**  曾任职公司 */
        beforeCompany: "",
        /** 毕业年份 */
        graduateLeft: "",
        graduateRight: "",
        /**  TQS模块使用 */
        useTQS: "",
        /**  绿夹克上课日期 */
        classDate: "",
        /**  关键字 */
        userSearchValue: "",
        /**  标签 */
        tagList: [],
        /**  分区 */
        subarea: "",
        /**  所属机构 */
        institution: [],
        /**  区域列表 */
        userLocationList: [
          {
            country: '',
            province: '',
            city: null,
            area: null
          }
        ]
      },
      /**  证书列表 */
      certificateList: [],
      /**  TQS模板使用列表 */
      tqsModuleList: [],
      /**  绿夹克上课名称列表 */
      courseNameList: [],
      /**  绿夹克上课日期 */
      classDateList: [],
      /**  优惠码级别 */
      promoCodeLevelOption: [],
      /**  优惠码列表 */
      couponCodeList: [],
      /**  标签选项列表 */
      tagOpList: [],
      /**  所属机构选项列表 */
      institutionOptList: [],
      /**  选择的用户 */
      multipleSelection: [],
      searchRules: {
        groupName: [
          {
            required: true,
            validator: validatorGroupName,
            trigger: ["blur", "change"]
          },
          {
            max: 255,
            validator: validatorGroupNameLength,
            trigger: ["blur", "change"]
          }
        ],
        groupDesc: [
          {
            max: 500,
            validator: validatorGroupDescLength,
            trigger: ["blur", "change"]
          }
        ],
        graduate: {
          require: false,
          validator: validatorGraduate,
          trigger: "blur change"
        }
      }
    };
  },
  methods: {
    getRowKey(row) {
      return row.userId;
    },
    handleAllSelChange(val) {
      const ulistIds = this.userList.map(item => item.userId);
      if (this.allSelFlg) {
        if (val && val.length > 0) {
          ulistIds.forEach(item => {
            if (!this.allUserIds.includes(item)) {
              this.allUserIds.push(item);
            }
          });
        } else {
          this.allUserIds = this.allUserIds.filter(item => !ulistIds.includes(item));
        }
      }
      this.multipleSelection = this.allUserIds;
      // 调整数据选中状态
      this.userList.forEach(item => {
        if (this.multipleSelection.includes(item.userId)) {
          this.$refs.userList.toggleRowSelection(item, true);
        } else {
          this.$refs.userList.toggleRowSelection(item, false);
        }
      });
      this.allSelFlg = true;
    },
    handleRowSelChange(val, row) {
      // 判断当前条是否存在
      if (this.allUserIds.includes(row.userId)) {
        // 若当前条存在，则去除
        this.allUserIds = this.allUserIds.filter(item => {
          return item !== row.userId;
        });
      } else {
        // 若当条不存在，则追加当前条
        this.allUserIds.push(row.userId);
      }
      this.multipleSelection = this.allUserIds;
      // 调整数据选中状态
      this.userList.forEach(item => {
        if (this.multipleSelection.includes(item.userId)) {
          this.$refs.userList.toggleRowSelection(item, true);
        } else {
          this.$refs.userList.toggleRowSelection(item, false);
        }
      });
    },
    /**  头像图片显示 */
    viewHeadPortrait(imgCodeStr) {
      return imgCodeStr == null
        ? this.defaultImg
        : "data:image/png;base64," + imgCodeStr;
    },
    /**  查询学员信息 */
    query() {
      if (
        (this.emailGroup.curCompany == undefined ||
          this.emailGroup.curCompany == "") &&
        (this.emailGroup.education == undefined ||
          this.emailGroup.education == "") &&
        (this.emailGroup.certificate == undefined ||
          this.emailGroup.certificate.length == 0) &&
        (this.emailGroup.className == undefined ||
          this.emailGroup.className.length == 0) &&
        (this.emailGroup.couponCodeLevel == undefined ||
          this.emailGroup.couponCodeLevel == "") &&
        (this.emailGroup.beforeCompany == undefined ||
          this.emailGroup.beforeCompany == "") &&
        (this.emailGroup.graduateLeft == undefined ||
          this.emailGroup.graduateLeft == "") &&
        (this.emailGroup.graduateRight == undefined ||
          this.emailGroup.graduateRight == "") &&
        (this.emailGroup.useTQS == undefined || this.emailGroup.useTQS == "") &&
        (this.emailGroup.classDate == undefined ||
          this.emailGroup.classDate == "") &&
        (this.emailGroup.userSearchValue == undefined ||
          this.emailGroup.userSearchValue == "") &&
        (this.emailGroup.tagList == undefined ||
          this.emailGroup.tagList.length == 0) &&
        (this.emailGroup.subarea == undefined ||
          this.emailGroup.subarea == "") &&
        (this.emailGroup.institution == undefined ||
          this.emailGroup.institution.length == 0) &&
        (this.emailGroup.userLocationList == undefined ||
          this.emailGroup.userLocationList.length == 0 ||
          (this.emailGroup.userLocationList.length == 1 &&
           (!this.emailGroup.userLocationList[0].country || this.emailGroup.userLocationList[0].country == '')))
      ) {
        this.$message.error("请输入查询条件!");
        return;
      }
      const that = this;
      this.$refs.searchForm.validateField("graduate", valid => {
        // console.log(valid);
        if (!valid) {
          that.searchEmailGroupUserInfoList(true);
        }
      });
    },
    // 重置搜索条件
    reset() {
      this.emailGroup = {
        groupName: this.emailGroup.groupName,
        groupDesc: this.emailGroup.groupDesc,
        tagList: [],
        subarea: "",
        institution: [],
        userLocationList: [
          {
            country: '',
            province: '',
            city: null,
            area: null
          }
        ]
      };
      this.userList = [];
      this.allUserIds = [];
      this.currentPage = 1;
      this.total = 0;
      this.showFlag = false;
      sessionStorage.setItem("P0401", "");
      this.multipleSelection = [];
      this.$refs.searchForm.resetFields();
    },
    // 添加区域
    addLocation() {
      this.emailGroup.userLocationList.push({
        country: '',
        province: '',
        city: null,
        area: null
      });
    },
    // 删除区域
    deleteLocation(userLocation) {
      if (this.emailGroup.userLocationList.length === 1) {
        // 如果只剩最后一个，重置它而不是删除
        this.emailGroup.userLocationList[0] = {
          country: '',
          province: '',
          city: null,
          area: null
        };
        return;
      }
      const index = this.emailGroup.userLocationList.indexOf(userLocation);
      if (index !== -1) {
        this.emailGroup.userLocationList.splice(index, 1);
      }
    },
    searchEmailGroupUserInfoList(val) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      if (val) {
        this.currentPage = 1;
        this.total = 0;
      }
      this.showFlag = true;
      let params;
      let url = "/api/emailGroup/searchUserInfo";
      params = {
        ...this.emailGroup
      };
      delete params.groupName;
      delete params.groupDesc;
      // 过滤掉空的区域
      if (params.userLocationList) {
        params.userLocationList = params.userLocationList.filter(loc =>
          loc.country && loc.country !== ''
        );
        if (params.userLocationList.length === 0) {
          delete params.userLocationList;
        }
      }
      // 添加分页参数
      params.currentSize = (this.currentPage - 1) * this.pageSize;
      params.pageSize = this.pageSize;
      params.total = this.total;
      this.$http
        .post(url, params)
        .then(response => {
          if (response.data.code === 200) {
            // 判断是否初始化
            if (this.currentPage == 1) {
              this.userList = response.data.data.userInfoList;
              if (val) {
                this.allUserIds = response.data.data.userIds;
              }
              if (this.userList && this.userList.length > 0) {
                this.total = this.userList[0].total || 0;
              }
            } else {
              this.userList = response.data.data.userInfoList;
              if (val) {
                this.allUserIds = response.data.data.userIds;
              }
            }
            this.$nextTick(() => {
              this.$refs.userList.clearSelection();
              this.$refs.userList.toggleAllSelection();
            });
            // console.log(response.data.data);
            loading.close();
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 分页改变事件
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchEmailGroupUserInfoList(false);
      this.allSelFlg = false;
    },
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.searchEmailGroupUserInfoList(false);
      this.allSelFlg = false;
    },
    /**  初始化取值 */
    createEmailGroupInit() {
      let url = "/api/emailGroup/createEmailGroupInit";
      this.$http
        .get(url)
        .then(response => {
          if (response.data.code === 200) {
            // console.log(response.data.data);
            this.educationList = response.data.data.educationList;
            this.tqsModuleList = response.data.data.tqsModuleList;
            this.certificateList = response.data.data.certificateList;
            this.courseNameList = response.data.data.courseNameList;
            this.promoCodeLevelOption = response.data.data.couponCodeLevelList;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
      // 获取标签选项列表
      this.getTagOptList();
      // 获取所属机构选项列表
      this.getInstitutionOptList();
    },
    /**  获取标签选项列表 */
    getTagOptList() {
      let url = "/api/resourceUserQuery/getTagOptList";
      this.$http
        .get(url)
        .then(response => {
          if (response.data.code === 200) {
            this.tagOpList = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    /**  获取所属机构选项列表 */
    getInstitutionOptList() {
      let url = "/api/resourceUserQuery/getInstitutionOptList";
      this.$http
        .get(url)
        .then(response => {
          if (response.data.code === 200) {
            this.institutionOptList = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    /**  根据课程查询排课时间 */
    getScheduleByCourse(courseNumber) {
      // console.log(courseNumber);
      let url = "/api/emailGroup/getScheduleByCourse";
      this.$http
        .post(url, courseNumber)
        .then(response => {
          if (response.data.code === 200) {
            // console.log(response.data.data);
            this.classDateList = response.data.data;
            // let classDate = this.classDateList[0].courseDate
            // console.log("🚀 ~ file: P0411.vue:362 ~ getScheduleByCourse ~ this.classDateList[0]", this.classDateList[0])
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    /**  创建并发送通知 */
    createAndNotify(row) {
      // console.log(row);
      let url = "/api/couponCode/createCouponCodeAndNotice";
      /**  this.$http */
      /**    .post(url, [row]) */
      /**    .then(response => { */
      /**      if (response.data.code === 200) { */
      /**        console.log(response.data); */
      /**        // this.classDateList = response.data.data; */
      /**        if (response.data.message === "error") { */
      /**        } else { */
      /**          this.$message.success(response.data.data); */
      /**          this.query(); */
      /**        } */
      /**      } else { */
      /**        this.$message.error(this.$t("common.anErrorOccurred")); */
      /**      } */
      /**    }) */
      /**    .catch(err => { */
      /**      console.log(err); */
      /**      this.$message.error(this.$t("common.anErrorOccurred")); */
      /**    }); */
    },
    handleSubmit() {
      this.$refs.searchForm.validateField("groupName", value => {
        if (!value) {
          if (this.multipleSelection && this.multipleSelection.length > 0) {
            this.addGroupMembers();
          } else {
            this.$message.error(this.$t("emailGroup.addMembers"));
          }
        }
      });
    },
    // 添加群成员
    addGroupMembers() {
      const userIds = this.multipleSelection;
      // .map(user => {
      // return user.userId
      // })
      // console.log('uids', userIds)
      if (!userIds || userIds.length == 0) {
        this.$message.error(this.$t("emailGroup.pleaseSelect"));
        return;
      }
      // console.log(userIds)
      let url = "/api/emailGroup/addGroupMembers";
      const date = {
        groupName: this.emailGroup.groupName,
        groupDescription: this.emailGroup.groupDesc,
        userIds: userIds
      };
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      this.$http
        .post(url, date)
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            this.reset();
            this.emailGroup.groupName = "";
            this.emailGroup.groupDesc = "";
            this.$message.success(response.data.data);
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    graduateChange() {
      this.$refs.searchForm.validateField("graduate");
    },
    // 个人用户详细信息取得
    detail(row) {
      // alert("功能开发中，请耐心等待！");
      let p0212 = JSON.stringify({
        userID: row.userId
      });
      sessionStorage.p0212 = p0212;
      sessionStorage.P0401 = JSON.stringify(this._data);
      // 跳转指定页面
      this.$router.push({
        path: "/views/CustomerInfoBase/P0213"
      });
    },
    initData() {
      // 初始化参数
      let P0401 = sessionStorage.getItem("P0401");
      if (P0401) {
        P0401 = JSON.parse(P0401);
        this.emailGroup = P0401.emailGroup;
        this.showFlag = P0401.showFlag;
        this.userList = P0401.userList;
        this.allUserIds = P0401.allUserIds;
        this.multipleSelection = P0401.multipleSelection;
        if (P0401.currentPage) {
          this.currentPage = P0401.currentPage;
        }
        if (P0401.total) {
          this.total = P0401.total;
        }
        // if(this.multipleSelection){
        //   this.multipleSelection.forEach((user)=>{
        //     this.$refs.userList.toggleRowSelection(user.userId)
        //   })
        // }
        this.$nextTick(() => {
          if (this.multipleSelection) {
            // 调整数据选中状态
            this.userList.forEach(item => {
              if (this.multipleSelection.includes(item.userId)) {
                this.$refs.userList.toggleRowSelection(item, true);
              } else {
                this.$refs.userList.toggleRowSelection(item, false);
              }
            });
          }
          sessionStorage.setItem("P0401", "");
        });
      }
    },
    // 导出
    exportExcel() {
      let data = undefined;
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        data = this.multipleSelection;
      } else {
        this.$message.error("未选择");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/emailGroup/exportExcel";
      this.$http
        .post(url, data, { responseType: "blob" })
        .then(response => {
          console.log("文件下载成功", response.data);
          const blob = new Blob([response.data]);
          console.log("blob", blob);
          this.formVisible = false;
          if (blob.size == 0) {
            this.$message({
              message: this.$t("p0212.existCoupon"),
              type: "warning"
            });
            loading.close();
          } else {
            const fileName =
              (this.emailGroup.groupName !== ""
                ? this.emailGroup.groupName + " "
                : "") +
              this.$t("p0401.emailGroupQueryMemberListEmail") +
              this.$t("p0212.couponFileFormat");
            //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            //IE10以上支持blob，但是依然不支持download
            if ("download" in document.createElement("a")) {
              // console.log("download1");
              //支持a标签download的浏览器
              const link = document.createElement("a"); //创建a标签
              link.download = fileName; //a标签添加属性
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click(); //执行下载
              URL.revokeObjectURL(link.href); //释放url
              document.body.removeChild(link); //释放标签
            } else {
              // console.log("download2");
              navigator.msSaveBlob(blob, fileName);
            }
            loading.close();
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("p0212.errorCoupon"));
          loading.close();
        });
    }
  },
  async mounted() {
    this.initData();
    this.createEmailGroupInit();
    // 初始化区域数据
    if (this.emailGroup.userLocationList && this.emailGroup.userLocationList.length > 0) {
      for (let index = 0; index < this.emailGroup.userLocationList.length; index++) {
        await this.$nextTick();
        if (this.$refs[`RegionSelectionRef${index}`] && this.$refs[`RegionSelectionRef${index}`][0]) {
          await this.$refs[`RegionSelectionRef${index}`][0].getChineArea();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table .cell {
  line-height: 28px;
}

>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 14px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

.foot-container {
  margin-top: 5%;
  // margin-left: 38%;
  margin: 5% auto;
  width: 20%;
  text-align: center;
}
/*.foot-container >>> .el-button*/
>>> .el-button--return {
  /*width: 97px;*/
  white-space: unset;
}

>>> .buttonWidth {
  width: 61px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}

>>> .el-table .el-table__cell {
  padding: 8.5px 0;
}

>>> .el-button--submit {
  white-space: unset;
}
>>> .el-button--return {
  white-space: unset;
}
>>> .el-button--submit:focus,
>>> .el-button--submit:hover,
>>> .el-button--p0332Button:focus,
>>> .el-button--p0332Button {
  white-space: unset;
}
>>> .el-button--p0332Button:hover {
  white-space: unset;
}
// 加号图标的样式
.add-icon {
  float: left;
  position: relative;
  top: 13px;
  left: 10px;
  cursor: pointer;
}

// 减号图标的样式
.subtract-icon {
  float: left;
  position: relative;
  top: 18px;
  left: 9px;
  cursor: pointer;
}

.plusAndMinus {
  text-align: left;
}

.baseTab-inputWidth {
  width: 100% !important;
}

.region-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-height: 100%;
  padding: 4px 0;
}

.region-item {
  line-height: 1.8;
  white-space: nowrap;
}

.pagination-container {
  text-align: right;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-right: 5%;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/EmailMarketing/P0401.vue